import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditEmployee from '../../components/employees/FormAddEditEmployee';

const CreateEmployee = () => (<WrapperSection><GlobalBreadcrumbs /><FormAddEditEmployee /></WrapperSection>);
export default CreateEmployee;
